module.exports = __webpack_public_path__ + "media/images/nav_icons/maintenance-1927489041cf1bd1d0f274a40f24c0d0.png";